export default __webpack_public_path__ + "dbe042dcd436e933cd52c7b7e575c1ba.svg";